import { useForm } from "@mantine/form"
import { notifications } from "@mantine/notifications"
import React, { useEffect, useState } from "react"
import { BaseModal } from "./BaseModal"
import { Box, Button, Group, ScrollArea, Stack, Text, TextInput } from "@mantine/core"

interface Props {
  opened: boolean
  onClose: () => void
  urlName: string
  files: File[]
  onUpload: (files: File[], directory: string) => Promise<void>
}

interface FormValues {
  directory: string
}

const UploadForm = ({ opened, onClose, urlName, files, onUpload }: Props) => {
  const [submitting, setSubmitting] = useState(false)

  const form = useForm<FormValues>({
    initialValues: { directory: '' },
    validate: {
      directory: (value) =>
        !value?.trim() ? 'ディレクトリ名を入力してください' : null,
    },
  })

  useEffect(() => {
    if (opened) {
      form.setValues({ directory: '' })
      form.resetDirty()
    }
  }, [opened])

  const handleSubmit = async (values: FormValues) => {
    setSubmitting(true)
    try {
      await onUpload(files, values.directory)
      notifications.show({ message: 'ファイルをアップロードしました', color: 'teal' })
      onClose()
    } catch (e) {
      console.error('ファイルのアップロードに失敗しました', e)
      notifications.show({ message: 'ファイルのアップロードに失敗しました', color: 'red' })
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <BaseModal
      opened={opened}
      onClose={onClose}
      title="アップロードするディレクトリを入力"
      width={560}
    >
      <form
        onSubmit={form.onSubmit(handleSubmit)}
        style={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 }}
      >
        <ScrollArea style={{ flex: 1, minHeight: 0 }} bg="#00000008" px={24}>
          <Stack gap="md" p="md">
            <Group gap={4} align="flex-start" wrap="nowrap">
              <Text pt={7} style={{ whiteSpace: 'nowrap' }}>/upload/{urlName}/</Text>
              <TextInput
                style={{ flex: 1 }}
                placeholder="ディレクトリ名を入力してください"
                {...form.getInputProps('directory')}
              />
            </Group>
          </Stack>
        </ScrollArea>

        <Box
          p="md"
          style={{
            borderTop: '1px solid #0000001A',
            backgroundColor: '#fff',
            flexShrink: 0,
          }}
        >
          <Group justify="flex-end" gap={8}>
            <Button
              type="submit"
              variant="filled"
              radius="xl"
              color={submitting ? 'gray' : 'invy'}
              fz={13}
              fw={600}
              w={120}
              disabled={submitting}
            >
              {submitting ? '処理中' : 'アップロード'}
            </Button>
          </Group>
        </Box>
      </form>
    </BaseModal>
  )
}

export default UploadForm
